import { getMarketingData } from '@nubank/www-latam-commons/utils/marketingUtils';
import getPersona from 'tracking/navegg/getPersona';
import { trackApplication } from 'tracking/application/registration';
import {
  trackRTRStart,
  trackRTRApproval,
  trackRTRDenial,
} from 'tracking/application/rtr';
import { sentryException } from 'services/errorTracking/sentryException';

import setReturningApplicant from './core/setReturningApplicant';
import startRealTimeAnalysis from './core/startRealTimeAnalysis';
import applicationRepository from './repository/application';
import realTimeAnalysisRepository from './repository/realTimeAnalysis';
import discoveryRepository from './repository/discovery';

export function createRegisterProspect(core, repository) {
  return async ({
    prospect,
    prospectType,
    fromInviter,
    onThrottledResponse,
    onAnalysisStart,
    onAnalysisFinish,
    onApplicationFinish,
  }) => {
    const additionalParameters = {};
    const typeOfProspectType = prospectType.type;

    try {
      additionalParameters.navegg_profile = await repository.getPersona();
    } catch (error) {
      sentryException({
        error,
        flow: 'application_flow',
        checkpoint: 'get_navegg_persona',
        namespace: 'createRegisterProspect()',
      });
    }

    const payload = {
      prospect,
      marketing: repository.getMarketingData({ additionalParameters }),
      'accepted-contracts': [
        {
          name: 'politica_privacidade_2020_08_10',
        },
      ],
    };

    const registerUrl = await repository.getRegistrationURL(prospectType, fromInviter);

    const {
      marketingId,
      hasThrottle,
      hasRealtimeAnalysis,
      realtimeUrl,
    } = await repository.sendProspectApplication(registerUrl, payload);

    if (hasThrottle) {
      onThrottledResponse();
      return {};
    }

    repository.trackApplication({
      prospectType: typeOfProspectType,
      marketingId,
    });

    core.setReturningApplicant(typeOfProspectType);

    if (hasRealtimeAnalysis) {
      onAnalysisStart();

      repository.trackRTRStart({
        prospectType: typeOfProspectType,
        marketingId,
      });

      const pollingConfig = await repository.getPollingConfig(realtimeUrl);

      if (pollingConfig) {
        const analysisResult = await core.startRealTimeAnalysis({
          url: realtimeUrl,
          pollingConfig,
        });

        const approvedProducts = analysisResult?.template?.id;
        const trackingFn = approvedProducts ? 'trackRTRApproval' : 'trackRTRDenial';

        repository[trackingFn]({
          prospectType: typeOfProspectType,
          marketingId,
          approvedProducts,
        });

        onAnalysisFinish({
          analysisResult,
          prospect: {
            prospectType: typeOfProspectType,
            marketingId,
          },
        });

        return { marketingId };
      }

      onAnalysisFinish(false);

      return { marketingId };
    }

    onApplicationFinish(false);

    return { marketingId };
  };
}

export default createRegisterProspect(
  {
    startRealTimeAnalysis,
    setReturningApplicant,
  },
  {
    ...applicationRepository,
    ...realTimeAnalysisRepository,
    ...discoveryRepository,
    getMarketingData,
    getPersona,
    trackApplication,
    trackRTRStart,
    trackRTRApproval,
    trackRTRDenial,
  },
);
